export const ThinkingIndicator = () => {
  return (
    <div className="nut-w-4 nut-h-4 nut-flex nut-items-center nut-justify-center nut-transition-opacity">
      <div className="nut-w-3 nut-h-3 nut-bg-gray-400 nut-rounded-full nut-animate-pulse-bubble"></div>
    </div>
  );
};
